import styled from 'styled-components';
import withCollapse from 'enhancers/withCollapse';
import Box from 'elements/Box';

const FixedFooter = withCollapse(styled(Box)(({ theme }) => `
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
`));

export default FixedFooter;
